import initTypes from './initTypes'

export const getEquipmentTypes = () => ({
  type: initTypes.GET_EQUIPMENT_TYPES
})

export const getEquipmentTypesSuccess = payload => ({
  type: initTypes.GET_EQUIPMENT_TYPES_SUCCESS,
  payload
})

export const getEquipmentTypesFailure = payload => ({
  type: initTypes.GET_EQUIPMENT_TYPES_FAILURE,
  payload
})

export const getTimeZone = () => ({
  type: initTypes.GET_TIMEZONE
})

export const getTimeZoneSuccess = payload => ({
  type: initTypes.GET_TIMEZONE_SUCCESS,
  payload
})

export const getTimeZoneFailure = payload => ({
  type: initTypes.GET_TIMEZONE_FAILURE,
  payload
})
export const getHotOffers = () => ({
  type: initTypes.GET_HOT_OFFERS
})

export const getHotOffersSuccess = payload => ({
  type: initTypes.GET_HOT_OFFERS_SUCCESS,
  payload
})

export const getOffers = () => ({
  type: initTypes.GET_OFFERS
})

export const getOffersSuccess = payload => ({
  type: initTypes.GET_OFFERS_SUCCESS,
  payload
})

export const hotOffersSeen = payload => ({
  type: initTypes.HOT_OFFERS_SEEN,
  payload
})

export const getAvatar = () => ({
  type: initTypes.GET_AVATAR
})

export const getAvatarSuccess = payload => ({
  type: initTypes.GET_AVATAR_SUCCESS,
  payload
})
